import { render } from "./ChiTietBaiVietTheoTen.vue?vue&type=template&id=206b0d30&scoped=true"
import script from "./ChiTietBaiVietTheoTen.vue?vue&type=script&lang=js"
export * from "./ChiTietBaiVietTheoTen.vue?vue&type=script&lang=js"

import "./ChiTietBaiVietTheoTen.vue?vue&type=style&index=0&id=206b0d30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206b0d30"]])

export default __exports__